import { render } from "./SimpleTopNav.vue?vue&type=template&id=5f3beab9&scoped=true"
const script = {}

import "./SimpleTopNav.vue?vue&type=style&index=0&id=5f3beab9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3beab9"]])

export default __exports__